import {atom } from 'recoil';

export const categoriesList = new atom({
    key: 'categoriesListState',
    default: ['Study', 'Tourism', 'Work', 'Permanent Visa'],
})